import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';
import { OperatorInfo } from 'src/models/operator-info/OperatorInfo';

import { BusinessSubList } from './BusinessSubList';

/**
 * # Business
 *
 * Business을 설명하세요.
 */
export const Business = types
  .model('Business')
  .props({
    langCd: types.maybeNull(types.string),
    businessSid: types.maybeNull(types.number),
    categorySid: types.maybeNull(types.number), // bnCatCd
    pipelineSid: types.maybeNull(types.string),
    title: types.maybeNull(types.string),
    useYn: types.optional(types.boolean, true),
    delYn: types.maybeNull(types.boolean),
    ordr: types.maybeNull(types.number),
    summary: types.maybeNull(types.string),
    descript: types.maybeNull(types.string),
    link: types.maybeNull(types.string),
    thumbPath: types.maybeNull(types.string),
    desktopImgPath: types.maybeNull(types.array(types.string)),
    mobileImgPath: types.maybeNull(types.array(types.string)),
    regDt: types.optional(types.maybeNull(types.number), 0),
    updDt: types.optional(types.maybeNull(types.number), 0),
    regUser: types.maybeNull(OperatorInfo),
    updUser: types.maybeNull(OperatorInfo),
    businessSubList: types.maybeNull(types.array(BusinessSubList)),
  })
  .volatile(() => ({
    // 썸네일
    thumbnail: [] as File[],
    deleteThumbPathFiles: [] as string[],
    // 데스크탑 이미지
    desktopImageFiles: [] as File[],
    deleteDesktopImageFiles: [] as string[],
    // 모바일 이미지
    mobileImageFiles: [] as File[],
    deleteMobileImageFiles: [] as string[],
  }))
  .actions(withSetPropAction);

// --------------------------------------------------------------------------
type TBusiness = Instance<typeof Business>;
type TBusinessSnapshot = SnapshotOut<typeof Business>;

export interface IBusiness extends TBusiness {}
export type TBusinessKeys = keyof TBusinessSnapshot & string;
export interface IBusinessSnapshot extends TBusinessSnapshot {}
export const createBusiness = () => types.optional(Business, {} as TBusiness);
